import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// A public demo must remain public even when an employee is already signed in.
// This does not grant access to CRM, paid Compass, or proprietary Bench routes.
export default function StaffRouteGuard() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "") || "/";
  const allowed = ["/clients", "/login", "/crm/activate", "/compass/demo"];
  return user?.role === "crm_staff" && !allowed.includes(path)
    ? <Navigate to="/clients" replace /> : null;
}
